import React, { useState, useEffect, useContext } from "react";
import { useTranslation } from 'react-i18next';
import './endereco-modern.css'
import '../../styles/page-titles.css'
import styled from 'styled-components';
import InputMask from 'react-input-mask'
import { getPostalCodeMask } from '../../utils/addressProvider';
import regionConfig from '../../config/regionConfig';
import CountrySelectField from '../../components/CountrySelectField';

import Map from './index'
import { getStoredUser } from '../../utils/safeStorage';

import { SidebarContext } from "../../AppRoutes";

import { updateEmpresaAddress, getEmpresa } from "../../services/api";

import PermissionGate from "../../services/PermissionGate";

import { useNavigate } from "react-router-dom";

import { useFormik } from "formik";
import * as Yup from "yup";

import { AiOutlineSave, AiOutlineLoading3Quarters } from 'react-icons/ai';
import { FiMapPin, FiHome, FiHash, FiMap, FiGlobe } from 'react-icons/fi';
import { MdLocationPin, MdLocationCity } from "react-icons/md";
import { BiBuildings } from 'react-icons/bi';
import { HiOutlineLocationMarker } from 'react-icons/hi';
import { FaMapMarkerAlt } from 'react-icons/fa';

import { toast } from "react-toastify";

const PageWrapper = styled.div`
    display: flex;
    margin-left: ${({ sidebar }) => (sidebar ? '250px' : '100px')};
    min-height: 100vh;
    width: auto;
    transition: margin-left 200ms ease;
    background-color: #ffffff;
    overflow: initial;
    z-index: 9;

    @media (max-width: 880px) {
        margin-left: 0;
    }
`;

const EnderecoEstabelecimento = ({ embedded = false }) => {
    const { t } = useTranslation('storeInfo');
    const userParse = getStoredUser();
    const userID = userParse?._id;

    const empresa = localStorage.getItem('empresa')
    const empresaParse = JSON.parse(empresa)
    const idEmpresa = empresaParse.id_empresa;

    const { sidebar } = useContext(SidebarContext);
    const navigate = useNavigate();

    const [isSubmitting, setIsSubmitting] = useState(false);
    const [latitudeEmpresa, setLatitudeEmpresa] = useState(null);
    const [longitudeEmpresa, setLongitudeEmpresa] = useState(null);

    useEffect(() => {
        (async () => {
            const response = await getEmpresa();
            let latitude = parseFloat(response.data.empresa.latitude)
            let longitude = parseFloat(response.data.empresa.longitude)
            process.env.REACT_APP_ISDEVELOP === 'true' && console.log("empresa:", response.data.empresa);

            // Fallback para coordenadas padrão da região se NaN/inválidas
            if (isNaN(latitude) || isNaN(longitude)) {
                latitude = regionConfig.map.defaultLat;
                longitude = regionConfig.map.defaultLng;
                process.env.REACT_APP_ISDEVELOP === 'true' && console.log(`[ENDERECO] Coordenadas inválidas, usando fallback da região:`, { latitude, longitude });
            }

            setLatitudeEmpresa(latitude)
            setLongitudeEmpresa(longitude)
            formik.setFieldValue("cep", response.data.empresa.cep);
            formik.setFieldValue("country", response.data.empresa.country || "");
            formik.setFieldValue("logradouro", response.data.empresa.logradouro);
            formik.setFieldValue("address_number", response.data.empresa.address_number);
            formik.setFieldValue("municipio", response.data.empresa.municipio);
            formik.setFieldValue("estado", response.data.empresa.estado);
            formik.setFieldValue("bairro", response.data.empresa.bairro);
            formik.setFieldValue("complemento", response.data.empresa.complemento);
        })();
        //eslint-disable-next-line
    }, []);

    const SignUpSchema = Yup.object().shape({
        cep: Yup.string().required(t('address.validation.required')),
        logradouro: Yup.string().required(t('address.validation.required')),
        address_number: Yup.string().required(t('address.validation.required')),
        municipio: Yup.string().required(t('address.validation.required')),
        estado: Yup.string().required(t('address.validation.required')),
        bairro: Yup.string().required(t('address.validation.required')),
    });

    const formik = useFormik({
        validationSchema: SignUpSchema,
        validateOnBlur: false,
        validateOnChange: false,
        initialValues: {
            cep: "",
            country: "",
            logradouro: "",
            address_number: "",
            municipio: "",
            estado: "",
            bairro: "",
            complemento: ""
        },
        onSubmit: (values) => {
            setIsSubmitting(true);
            handleSubmitAPI(values);
        },
    });

    const handleBack = () => {
        navigate("/");
    }

    const handleSubmitAPI = (values) => {
        const { cep, country, logradouro, address_number, municipio, estado, bairro, complemento } = values;
        const latitude = latitudeEmpresa.toString();
        const longitude = longitudeEmpresa.toString();
        const _id = empresaParse._id;
        const id = empresaParse.id_empresa;
        process.env.REACT_APP_ISDEVELOP === 'true' && console.log({ cep, country, logradouro, address_number, municipio, estado, bairro, complemento, latitude, longitude });

        updateEmpresaAddress(_id,
            id,
            userID,
            cep,
            estado,
            municipio,
            bairro,
            address_number,
            complemento,
            latitude,
            longitude,
            logradouro,
            country).then(cast => {
                if (cast.status === 200) {
                    toast(cast.data.msg, { autoClose: 5000, type: "success" });
                    // Update empresa in localStorage so PhoneInput picks up new country
                    try {
                        const stored = JSON.parse(localStorage.getItem('empresa') || '{}');
                        stored.country = country;
                        localStorage.setItem('empresa', JSON.stringify(stored));
                    } catch { /* ignore */ }
                    setIsSubmitting(false);
                }
                else {
                    toast(cast.data.msg, { autoClose: 5000, type: "error" });
                    setIsSubmitting(false);
                }

            }).catch(err => {
                process.env.REACT_APP_ISDEVELOP === 'true' && console.log('Oh noooo!!');
                const msg = err.response.data.msg;
                toast(msg, { autoClose: 5000, type: "error" });
                setIsSubmitting(false);
            });
    }

    const formContent = (
        <div className="endereco-wrapper">
            {/* Header com titulo e botao - Estilo igual Dados da Loja */}
            <div className="endereco-section-header">
                <div className="endereco-header-content">
                    <div className="endereco-header-icon">
                        <FaMapMarkerAlt />
                    </div>
                    <div>
                        <h2>{t('address.title', 'Endereco do Estabelecimento')}</h2>
                        <p>{t('address.subtitle', 'Localizacao do seu estabelecimento')}</p>
                    </div>
                </div>
                <button
                    type="submit"
                    form="endereco-form"
                    className="modern-btn modern-btn-save"
                    disabled={isSubmitting}
                >
                    {isSubmitting ? (
                        <AiOutlineLoading3Quarters className="endereco-btn-spinner" />
                    ) : (
                        <AiOutlineSave />
                    )}
                    {isSubmitting ? t('address.saving', 'Salvando...') : t('address.saveButton', 'Salvar')}
                </button>
            </div>

            {/* Card do Mapa */}
            <div className="endereco-map-card">
                <div className="endereco-map-header">
                    <div className="endereco-map-icon">
                        <HiOutlineLocationMarker />
                    </div>
                    <div className="endereco-map-info">
                        <h3>{t('address.mapInstruction')}</h3>
                        <p>
                            <MdLocationPin className="pin-icon" />
                            {t('address.dragMarkerHint')}
                        </p>
                    </div>
                </div>
                <div className="endereco-map-container">
                    {latitudeEmpresa && longitudeEmpresa ? (
                        <Map
                            latitudeEmpresa={latitudeEmpresa}
                            longitudeEmpresa={longitudeEmpresa}
                            setLatitudeEmpresa={setLatitudeEmpresa}
                            setLongitudeEmpresa={setLongitudeEmpresa}
                        />
                    ) : (
                        <div className="endereco-loading">
                            <div className="endereco-loading-spinner"></div>
                            <span>{t('loading')}</span>
                        </div>
                    )}
                </div>
            </div>

            {/* Card do Formulario */}
            <div className="endereco-form-card">
                <h2 className="endereco-form-title">
                    <FiMapPin />
                    {t('address.formTitle')}
                </h2>

                <form id="endereco-form" onSubmit={formik.handleSubmit}>
                    <div className="endereco-form-grid">
                        {/* Country - FIRST field */}
                        <div className="endereco-form-group">
                            <label className="endereco-form-label">
                                <FiGlobe />
                                {t('address.form.country', 'Country')}
                            </label>
                            <CountrySelectField
                                id="country"
                                name="country"
                                value={formik.values.country}
                                onChange={(iso) => formik.setFieldValue('country', iso)}
                                placeholder={t('address.form.countryPlaceholder', 'Select a country')}
                            />
                        </div>

                        {/* CEP */}
                        <div className="endereco-form-group">
                            <label className="endereco-form-label">
                                <FiHash />
                                {t('address.form.zipCode')}
                                <span className="required">*</span>
                            </label>
                            <InputMask
                                className="endereco-form-input"
                                placeholder={t('address.form.zipCodePlaceholder')}
                                id="cep"
                                name="cep"
                                mask={getPostalCodeMask()}
                                onChange={formik.handleChange}
                                value={formik.values.cep}
                            />
                            {formik.errors.cep && (
                                <div className="endereco-form-error">{formik.errors.cep}</div>
                            )}
                        </div>

                        {/* Numero */}
                        <div className="endereco-form-group">
                            <label className="endereco-form-label">
                                <FiHash />
                                {t('address.form.number')}
                                <span className="required">*</span>
                            </label>
                            <input
                                className="endereco-form-input"
                                placeholder={t('address.form.numberPlaceholder')}
                                id="address_number"
                                name="address_number"
                                onChange={formik.handleChange}
                                value={formik.values.address_number}
                            />
                            {formik.errors.address_number && (
                                <div className="endereco-form-error">{formik.errors.address_number}</div>
                            )}
                        </div>

                        {/* Logradouro */}
                        <div className="endereco-form-group full-width">
                            <label className="endereco-form-label">
                                <FiHome />
                                {t('address.form.street')}
                                <span className="required">*</span>
                            </label>
                            <input
                                className="endereco-form-input"
                                placeholder={t('address.form.streetPlaceholder')}
                                id="logradouro"
                                name="logradouro"
                                onChange={formik.handleChange}
                                value={formik.values.logradouro}
                            />
                            {formik.errors.logradouro && (
                                <div className="endereco-form-error">{formik.errors.logradouro}</div>
                            )}
                        </div>

                        {/* Bairro */}
                        <div className="endereco-form-group">
                            <label className="endereco-form-label">
                                <BiBuildings />
                                {t('address.form.neighborhood')}
                                <span className="required">*</span>
                            </label>
                            <input
                                className="endereco-form-input"
                                placeholder={t('address.form.neighborhoodPlaceholder')}
                                id="bairro"
                                name="bairro"
                                onChange={formik.handleChange}
                                value={formik.values.bairro}
                            />
                            {formik.errors.bairro && (
                                <div className="endereco-form-error">{formik.errors.bairro}</div>
                            )}
                        </div>

                        {/* Cidade */}
                        <div className="endereco-form-group">
                            <label className="endereco-form-label">
                                <MdLocationCity />
                                {t('address.form.city')}
                                <span className="required">*</span>
                            </label>
                            <input
                                className="endereco-form-input"
                                placeholder={t('address.form.cityPlaceholder')}
                                id="municipio"
                                name="municipio"
                                onChange={formik.handleChange}
                                value={formik.values.municipio}
                            />
                            {formik.errors.municipio && (
                                <div className="endereco-form-error">{formik.errors.municipio}</div>
                            )}
                        </div>

                        {/* Estado */}
                        <div className="endereco-form-group">
                            <label className="endereco-form-label">
                                <FiMap />
                                {t('address.form.state')}
                                <span className="required">*</span>
                            </label>
                            <input
                                className="endereco-form-input"
                                placeholder={t('address.form.statePlaceholder')}
                                id="estado"
                                name="estado"
                                onChange={formik.handleChange}
                                value={formik.values.estado}
                            />
                            {formik.errors.estado && (
                                <div className="endereco-form-error">{formik.errors.estado}</div>
                            )}
                        </div>

                        {/* Complemento */}
                        <div className="endereco-form-group">
                            <label className="endereco-form-label">
                                <FiMapPin />
                                {t('address.form.complement')}
                            </label>
                            <input
                                className="endereco-form-input"
                                placeholder={t('address.form.complementPlaceholder')}
                                id="complemento"
                                name="complemento"
                                onChange={formik.handleChange}
                                value={formik.values.complemento}
                            />
                            {formik.errors.complemento && (
                                <div className="endereco-form-error">{formik.errors.complemento}</div>
                            )}
                        </div>
                    </div>
                </form>
            </div>
        </div>
    );

    // Se estiver embedded, retorna apenas o conteudo sem wrapper
    if (embedded) {
        return formContent;
    }

    // Modo normal com wrapper completo
    return (
        <PermissionGate permissions={['default']}>
            <PageWrapper sidebar={sidebar}>
                <div className="pedeja-page-container">
                    <div className="pedeja-page-content">
                        {formContent}
                    </div>
                </div>
            </PageWrapper>
        </PermissionGate>
    );
};

export default EnderecoEstabelecimento;
